import { HStack, Icon, Text } from "@chakra-ui/react"
import { FaTruckDroplet } from "react-icons/fa6"
import { Tooltip } from "@hydrologiq/shared/chakra/Tooltip"
import { formatRunDryMinutes } from "@hydrologiq/shared/asset/attributes/RunDry"

interface SystemRunDryCellProps {
  runDryMinutes?: number | null
}

function SystemRunDryCell({ runDryMinutes }: SystemRunDryCellProps) {
  if (runDryMinutes == null) {
    return <Text color="fg.subtle" fontSize="1em">n/a</Text>
  }

  const formattedTime = formatRunDryMinutes(runDryMinutes)
  const tooltipContent = `Refuel needed in ${formattedTime}`

  return (
    <Tooltip content={tooltipContent}>
      <HStack
        gap="0.35em"
        display="inline-flex"
        alignItems="center"
        fontSize="1em"
        cursor="help"
      >
        <Text fontSize="1em" color="primary" fontWeight="500">
          {formattedTime}
        </Text>
        <Icon boxSize="1.15em" as={FaTruckDroplet} color="fg.muted" verticalAlign="middle" />
      </HStack>
    </Tooltip>
  )
}

export default SystemRunDryCell
